import React, { useState, useRef, useEffect } from "react";
import BackArrow from "../icons/BusinessHub/BackArrow";
import "../styles/EditUserDetails.css";
import BusinessHubHeader from "../components/BusinessHubHeader.js";
import SuccTickIcon from "../icons/BusinessHub/SuccTickIcon.js";
import { useNavigate } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import UserInfoInput from "./UserInfoInput.js";
import { useLocation } from "react-router-dom";
import { userService } from "../services/userService.js";
import Utils from "../utils/Utils.js";
import { toast } from "react-toastify";
import companyController from "../controllers/companyController.js";
import userController from "../controllers/userController.js";

function EditUserDetails() {
  const childRef = useRef();
  const { state } = useLocation();
  const { userId, roleName } = state || {};
  const { roleID: initialRoleID } = state || {};
  const [jwt, setjwt] = useState("");
  const [roleID, setRoleID] = useState(initialRoleID || "");
  const navigate = useNavigate();
  const [UserAdd, setUserAdded] = useState(false);
  useEffect(() => {
    setjwt(userService.getUser());
  }, []);
  useEffect(() => {}, [jwt]);

  const handleSaveChange = async () => {
    const Pjwt = Utils.parseJwt(jwt);
    try {
      const userdata = await userController.getUser({
        Jwt: jwt,
        userID: userId,
      });
      if (childRef.current) {
        // if (!data.roleID) {
        //   toast.error("Fill All Data");
        //   return;
        // }
        const addCompanyEmloyeeRequest = {
          adminID: Pjwt.id,
          birthdate: userdata.data.birthdate,
          companyID: userService.getCompID(),
          gender: {
            costumGenderName: null,
            genderName: userdata.data.gender.genderName,
            pronoun: userdata.data.gender.pronoun,
          },
          roleID: roleID,
          userID: state.userId,
          userRegister: {
            countryOfResidence: userdata.data.countryOfResidence
              ? userdata.data.countryOfResidence
              : "Lebanon",
            email: userdata.data.email,
            firstname: userdata.data.firstname,
            lastname: userdata.data.lastname,
            password: null,
            phoneNumber: userdata.data.phoneNumber,
            suffix: userdata.data.suffix,
            userType: "END_USER",
          },
        };
        const AddCompanyEmployees = await companyController.addCompanyEmployees(
          { jwt: jwt, addCompanyEmloyeeRequest: addCompanyEmloyeeRequest },
        );
        if (
          AddCompanyEmployees.data &&
          Utils.isSuccessResponse(AddCompanyEmployees)
        ) {
          setUserAdded(true);
        } else if (
          !AddCompanyEmployees.data &&
          !Utils.isSuccessResponse(AddCompanyEmployees)
        ) {
          toast.error(AddCompanyEmployees.response.data.message);
        }
      }
    } catch (err) {
      console.log(err, "");
    }
  };
  return (
    <div className="edit-user-screen-container">
      <div className="edit-user-page-header">
        <BusinessHubHeader />
      </div>
      <div className="edit-user-content-main-container">
        {UserAdd && (
          <div className="edit-user-popup-container">
            <div
              className="edit-user-popup-content-container"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="edit-user-popup-content">
                <div className="edit-user-successfully-added-icon">
                  <SuccTickIcon />
                </div>
                <div className="edit-user-successfully-added-text">
                  User Details Updated Successfully
                </div>
                <div
                  className="edit-user-successfully-added-action-button"
                  onClick={() =>
                    navigate("/user-management", {
                      state: { active: "C" },
                    })
                  }
                >
                  Continue
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="edit-user-content-container">
          <div className="edit-user-header">
            <div className="edit-user-header-navigation">
              <div
                className="edit-user-header-navigation-icon"
                onClick={() =>
                  navigate("/user-management", {
                    state: { active: "C" },
                  })
                }
              >
                <BackArrow />
              </div>
              <div className="edit-user-header-navigation-text">
                Back to User Management
              </div>
            </div>
            <div className="edit-user-header-text">
              <div className="edit-user-header-title">Edit User Details</div>
              <div className="edit-user-header-text-note">
                Update user information and role assignments
              </div>
            </div>
          </div>
          <div className="edit-user-body">
            <div className="edit-user-window-container">
              <div className="user-window-header">
                <div className="user-window-header-text-container">
                  <div className="user-window-title">Personal Information</div>
                  <div className="user-window-text">
                    Update the user's basic details
                  </div>
                </div>
              </div>
              <UserInfoInput
                ref={childRef}
                user={state}
                UserAdd={UserAdd}
                RoleID={roleID}
                setRoleid={setRoleID}
                setUserAdded={setUserAdded}
                mode="edit"
              />
              <div className="user-window-footer">
                <div className="user-window-footer-button-container">
                  <div
                    className="save-user-action-button"
                    onClick={() => handleSaveChange()}
                  >
                    Save Changes
                  </div>
                  <div className="canel-action-button-container">
                    <div
                      className="cancel-user-creation-action-button"
                      onClick={() =>
                        navigate("/user-management", {
                          state: { active: "C" },
                        })
                      }
                    >
                      Cancel
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditUserDetails;
